import { useState } from "react";

import RestrictedComponent from "common/components/RestrictedComponent";
import { ManageSubscriptionDialog } from "common/components/subscriptions";
import { Button } from "common/components/ui/Button";
import { getWhitelabelCustomization } from "common/helpers/utils";

export default function RentAccountsButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { whitelabelCustomization } = getWhitelabelCustomization();

  if (!whitelabelCustomization) {
    return (
      <RestrictedComponent visibleForPermissions={["billing_full"]}>
        <Button onClick={() => setIsOpen(true)} variant="secondary-purple">
          Rent accounts
        </Button>

        <ManageSubscriptionDialog
          plan="avatar"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      </RestrictedComponent>
    );
  }
}
